import { Box, Dialog, DialogContent, DialogTitle, Grid2, LinearProgress, Typography } from '@mui/material';
import { useMemo } from "react";
import Tabla from './tabla';
import TableHeader from './tableHeader';
import MButton from '../../inputs/yup/materialui/mButton';
import { exportExcel } from "../../../utils/exportExcel";
import SummarizeTwoToneIcon from '@mui/icons-material/SummarizeTwoTone';

interface ProgressInfo {
    total: number;
    procesados: number;
    exitosos: number;
    fallidos: number;
}

interface IProps<T> {
    open: boolean;
    onClose: () => void;
    title: string;
    data: T[];
    columns: any[];
    columnsExcel: any[];
    excelFileName: string;
    isProcessing?: boolean;
    progress?: ProgressInfo;
}

export const ModalResultados = <T extends unknown>({
    open,
    onClose,
    title,
    data,
    columns,
    columnsExcel,
    excelFileName,
    isProcessing = false,
    progress,
}: IProps<T>) => {

    const memoColumns = useMemo(() => columns, [columns]);
    const memoColumnsExcel = useMemo(() => columnsExcel, [columnsExcel]);

    const porcentaje = progress?.total ? Math.round((progress.procesados / progress.total) * 100) : 0;

    const handleClose = (_event: any, reason: any) => {
        if (isProcessing) return;
        if (reason === 'backdropClick') return;
        onClose();
    };

    const handleExportExcel = () => {
        exportExcel(data, memoColumnsExcel, excelFileName);
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="lg" fullWidth>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                {progress && (
                    <Box sx={{ mb: 2 }}>
                        <Typography variant="body2" sx={{ mb: 1 }}>
                            Procesados: {progress.procesados}/{progress.total} | Exitosos: {progress.exitosos} | Fallidos: {progress.fallidos}
                        </Typography>
                        <LinearProgress variant="determinate" value={porcentaje} />
                    </Box>
                )}

                <Tabla
                    data={data}
                    columns={memoColumns}
                    titulo={
                        <TableHeader
                            buttonExport={
                                <MButton
                                    type="button"
                                    variant="outlined"
                                    onClick={handleExportExcel}
                                    startIcon={<SummarizeTwoToneIcon />}
                                    disabled={isProcessing}
                                >
                                    Exportar
                                </MButton>
                            }
                        />
                    }
                />
                <Grid2 size={4} sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", marginTop: "15px" }}>
                    <MButton onClick={onClose} variant="contained" color="primary" disabled={isProcessing}>
                        OK
                    </MButton>
                </Grid2>
            </DialogContent>
        </Dialog>
    );
};
